import { type ExtractPropTypes, computed, type PropType } from 'vue';

import { type JustifyType, type JustifyBreakpointType, justifyList } from '../../typings/justifyType';
import { BreakpointDepended } from '../breakpointDepended';
import { defaults } from '../defaults';

export function withJustifyProps(defaultValue?: JustifyType | JustifyBreakpointType) {
  return {
    /**
     * Justowanie elementu (flex)
     */
    justify: {
      type: [String, Object] as PropType<JustifyType | JustifyBreakpointType>,
      default: defaultValue
    }
  };
}

/**
 * Zwraca klasy justowania (flex)
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withJustifyProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useJustifyProps = (prefix: string, props: ExtractPropTypes<ReturnType<typeof withJustifyProps>>) => {
  return computed(() => {
    if (typeof props.justify === 'string') {
      return `${prefix}--justify-${props.justify}`;
    }
    if (BreakpointDepended(props.justify).value) {
      return `${prefix}--justify-${BreakpointDepended(props.justify).value}`;
    }
    return;
  });
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesJusitfyArgs = {
  args: {
    justify: defaults.flex.justify
  },

  argTypes: {
    justify: {
      options: justifyList,
      control: { type: 'select' }
    }
  }
};
